module.exports = __webpack_public_path__ + "img/act_pro_img14s_03.2b0c718b.png";